<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="company-notes">
            <b-card :title="componentName" class="inner-page p-3">
                <b-card-body>
                        <b-table :items="items" :fields="fields" class="mt-2">
                            <template #cell(control)="{ index, item }">
                                <b-button :id="'add-notes-btn'+index" class="test-add-notes-btn" v-if="index == items.length - 1 && hasPermissionCreate" variant="link"
                                    @click="addNote(item)"> <img src="@/assets/images/icon/blue-add.svg" />
                                </b-button>
                                <b-button :id="'delete-notes-btn-'+index"  v-if="index !== items.length - 1 && hasPermissionDelete" class="ms-3 test-delete-notes-btn"
                                    variant="pink-button" @click="deleteNote(index)"><img src="@/assets/images/icon/delete.svg" />
                                </b-button>
                            </template>

                            <template #cell(name)="{ index, item, value }">
                                <b-form-input class="test-input-name" v-if="index == items.length - 1" :id="`input-name${index}`" :placeholder="$translate('name')"
                                    v-model="item.name" type="text"></b-form-input>

                                <span v-else>{{ value }}</span>
                            </template>

                            <template #cell(value)="{ index, item, value }">
                                <b-form-input class="test-input-value" v-if="index == items.length - 1" :id="`input-value${index}`" :placeholder="$translate('value')"
                                    v-model="item.value" type="text"></b-form-input>

                                <span v-else>{{ value }}</span>
                            </template>
                        </b-table>
                </b-card-body>
            </b-card>
        </div>
    </b-overlay>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'companyNotes',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        model: {
            notes: [],
        },
        updating: false,
        loading: false
    }),

    computed: {
        fields() {
            return [
                { key: 'name', label: this.$translate('name') },
                { key: 'value', label: this.$translate('value') },
                { key: 'control', label: '' }
            ]
        },
        componentName() { return this.$translate('company_notes') },
        notes() {
            const resp = this.$store.getters['company/companyNotes']
            const notes = (resp && resp.notes) || []
            return notes
        },
        settingKeys() {
            return this.$store.state.company.settingKeys.companyNoteKey
        },
        items() {
            return [...this.model.notes, { name: '', value: '' }]
        },
    },

    watch: {
        notes: {
            handler: function (val) {
                console.log('watch notes', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },
    async mounted() {
        const { settingKeys } = this
        console.log('settingKeys', settingKeys)
        await this.$store.dispatch('company/fetchConfiguration', settingKeys)
        this.$nextTick(() => {
            this.updateModel(this.notes)
        })
    },

    methods: {
        updateModel(notes) {
            console.log('notes-------------', notes)
            // const { notes } = companyNotes
            this.$set(this.model, 'notes', notes)
        },
        async updateSettings(type, name, message) {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.model)
                const bool_value = false

               await this.$store.dispatch('company/updateConfiguration', {
                    key: this.settingKeys,
                    text_value,
                    bool_value,
                })

                this.genericToast(this.componentName, type, 'success', `"${name}" ${message}`)
                //this.doToast('Success!', 'Settings Updated', 'success')

            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        addNote: function ({ name, value }) {
            const noDuplicate = (value) => { return value === true ? this.$translate('error') : this.$translate('duplicate') }
            this.loading = true;
            try {
                if (!name || !value) {
                    const action = noDuplicate(true)
                    throw { name: action, message: this.$translate('complete_all_alert') }

                }
                if (!this.$escapeSpecialCharRule.test(name)) {
                    throw Error(this.$translate('name_regex_alert'))
                }
                if (!this.$escapeSpecialCharRule.test(value)) {
                    throw Error(this.$translate('value_regex_alert'))
                }

                if (this.model.notes.some(x => x.name === name)) {
                    const action = noDuplicate(false)

                    throw { name: action, message: `"${name}" ${this.$translate('duplicate_name_alert')}` }

                }

                this.model.notes.push({
                    name,
                    value,
                })
                this.$nextTick(() => {
                    this.updateSettings(this.$translate('created'), name, this.$translate('create_alert'))
                    this.loading = false;
                })
            } catch (error) {
                console.log(error)
                this.doToast(error.name, error.message, 'danger')
                this.loading = false;
            }
        },
        deleteNote: function (index) {
            console.log('>> ', index)
            this.loading = true
            let currentIndex = this.model.notes[index].name
            this.model.notes.splice(index, 1)
            this.$nextTick(() => {
                this.updateSettings(this.$translate('deleted'), currentIndex, this.$translate('delete_alert'))
                this.loading = false
            })
        },
    },
}
</script>
